import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

/**
 * A component for determining column grid layout
 */
function Column({
  xs,
  sm,
  md,
  lg,
  xsOffset,
  smOffset,
  mdOffset,
  lgOffset,
  xsPush,
  smPush,
  mdPush,
  lgPush,
  xsPull,
  smPull,
  mdPull,
  lgPull,
  className,
  children
}) {
  return (
    <div
      className={classNames(
        {
          ['gel-content-col-xs-' + xs]: xs,
          ['gel-content-col-sm-' + sm]: sm,
          ['gel-content-col-md-' + md]: md,
          ['gel-content-col-lg-' + lg]: lg,
          ['gel-content-col-xs-offset-' + xsOffset]: xsOffset,
          ['gel-content-col-sm-offset-' + smOffset]: smOffset,
          ['gel-content-col-md-offset-' + mdOffset]: mdOffset,
          ['gel-content-col-lg-offset-' + lgOffset]: lgOffset,
          ['gel-content-col-xs-push-' + xsPush]: xsPush,
          ['gel-content-col-sm-push-' + smPush]: smPush,
          ['gel-content-col-md-push-' + mdPush]: mdPush,
          ['gel-content-col-lg-push-' + lgPush]: lgPush,
          ['gel-content-col-xs-pull-' + xsPull]: xsPull,
          ['gel-content-col-sm-pull-' + smPull]: smPull,
          ['gel-content-col-md-pull-' + mdPull]: mdPull,
          ['gel-content-col-lg-pull-' + lgPull]: lgPull
        },
        className
      )}
    >
      {children}
    </div>
  );
}

Column.propTypes = {
  /**
   * The extra small column span
   */
  xs: PropTypes.number,
  /**
   * The small column span
   */
  sm: PropTypes.number,
  /**
   * The medium column span
   */
  md: PropTypes.number,
  /**
   * The large column span
   */
  lg: PropTypes.number,
  /**
   * The extra small offset
   */
  xsOffset: PropTypes.number,
  /**
   * The small offset
   */
  smOffset: PropTypes.number,
  /**
   * The medium offset
   */
  mdOffset: PropTypes.number,
  /**
   * The large offset
   */
  lgOffset: PropTypes.number,
  /**
   * The extra small push
   */
  xsPush: PropTypes.number,
  /**
   * The small push
   */
  smPush: PropTypes.number,
  /**
   * The medium push
   */
  mdPush: PropTypes.number,
  /**
   * The large push
   */
  lgPush: PropTypes.number,
  /**
   * The extra small pull
   */
  xsPull: PropTypes.number,
  /**
   * The small pull
   */
  smPull: PropTypes.number,
  /**
   * The medium pull
   */
  mdPull: PropTypes.number,
  /**
   * The large pull
   */
  lgPull: PropTypes.number,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default Column;
